import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useState, lazy as ReactLazy, Suspense, createContext } from 'react';
import Navbar, { checkclickoutside } from './Navbar';
import { NavLink } from './Navbar';
import $ from 'jquery'
import xsvg from './x.svg'
import Galerie from './Galerie';
import ContactUs from './ContactUs';
import Blogs from './Blogs';
import Blog from './Blog';
import Login from './Login';
import Home from './Home';
import Shop from './Shop';
import Profile from './Profile';
import Map from './Map';
import Users from './Users';
import CreateUser from './CreateUser';
import NotFound from './404';
import EditProfile from './EditProfile';
import EditPassword from './EditPassword';
import { isAdmin, isEmptyOrSpaces, isLoggedIn, setGlobalContextStore, ShowConditonally } from './util';
import submitsearch from './magnifier.png'
import Test from './Test';
import PreviewBlog from './PreviewBlog';
import { useEffect } from 'react';

// const Blogs = ReactLazy(() => import('./Blogs'))
// const EditPassword = ReactLazy(() => import('./EditPassword'))
// import CreateNewBlog from './CreateNewBlog';
const EditBlog = ReactLazy(() => import("./EditBlog"));
const CreateNewBlog = ReactLazy(() => import("./CreateNewBlog"));

export const globalContext = createContext();

function LoggedIn({ children, secondCond }) {
	if (secondCond === undefined)
		secondCond = true
	return (
		<ShowConditonally cond={isLoggedIn() && secondCond}>
			{children}
		</ShowConditonally>
	)
}


function App() {
	const [globalBlogs, setGlobalBlogs] = useState(null);
	const [globalBlog, setGlobalBlog] = useState(null);
	const [previewBlog, setPreviewBlog] = useState(null);
	const [loggedIn, setLoggedIn] = useState(isLoggedIn());
	const location = useLocation()

	useEffect(() => {
		var pathname = location.pathname;
		if (pathname !== "/preview" && pathname !== "/create-new-blog" && !pathname.startsWith("/edit")) {
			setPreviewBlog(null);
		}
	}, [location])

	useEffect(() => {
		setLoggedIn(isLoggedIn());
	}, [location])

	var onClick = () => {
		$("#slidingmenu").removeClass("togglemenu")
		window.removeEventListener('click', checkclickoutside)
		// setPreviewBlog(null)
	}

	return (
		<globalContext.Provider
			value={(() => {
				return setGlobalContextStore({
					previewBlog,
					setPreviewBlog,
					globalBlog,
					setGlobalBlog,
					globalBlogs,
					setGlobalBlogs,
					loggedIn,
					setLoggedIn
				})
			})()}
		>
			<div className="App">
				<div className="pagebg"> </div>
				<div id="slidingmenu" className="slidingmenu flex-column flex-gap15 flex-jc-cr">
					<img onClick={onClick} src={xsvg} alt="" />
					<form action="" className="searchform" onSubmit={(e) => {
						e.preventDefault()
						if (!isEmptyOrSpaces($("#slidingmenublogquery").val()))
							window.location = "/blogs?name=" + $("#slidingmenublogquery").val()
					}}>
						<div style={{ width: "30px" }} ></div>
						<input type="text" className="searchbox sb" placeholder='SEARCH' id="slidingmenublogquery" style={{ height: "20px", paddingRight: "25px" }} />
						<input type="image" className='submitbutton sb' alt="" src={submitsearch} style={{ transform: "translateX(-37px) scale(.7)" }} />
					</form>
					<NavLink onClick={onClick} cls={"home"} match={[""]} />
					<a onClick={onClick} className={"navtext navlistitem navlink shop"} style={{ textDecoration: "none" }} href="https://shop.pcbang.ma">Shop</a>
					<NavLink onClick={onClick} cls={"blogs"} />

					<NavLink onClick={onClick} cls={"galerie"} />
					<NavLink onClick={onClick} cls={"map"} />
					<NavLink onClick={onClick} cls={"contact"} match={["contact-us"]} />
				</div>
				<Navbar />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/home" element={<Home />} />

					<Route path="/shop" element={<Shop />} />

					<Route path="/galerie" element={<Galerie />} />

					<Route path="/contact-us" element={<ContactUs />} />
					<Route path="/contact" element={<ContactUs />} />

					<Route path="/login" element={
						<ShowConditonally cond={!isLoggedIn()}>
							<Login />
							<Navigate to="/blogs" />
						</ShowConditonally>
					} />
					<Route path="/admin" element={
						<ShowConditonally cond={!isLoggedIn()}>
							<Login />
							<Navigate to="/blogs" />
						</ShowConditonally>
					} />

					<Route path="/blogs" element={<Blogs />} />
					<Route path="/blogs/*" element={<Blog />} />

					<Route path="/map" element={<Map />} />

					<Route path="/edit/*" element={
						<LoggedIn>
							<Suspense fallback={<></>} >
								<EditBlog />
							</Suspense>
							<Navigate to="/blogs" replace />
						</LoggedIn>
					} />
					<Route path="/create-new-blog" element={
						<LoggedIn>
							<Suspense fallback={<></>} >
								<CreateNewBlog />
							</Suspense>
							<Navigate to="/blogs" replace />
						</LoggedIn>
					} />

					<Route path="/preview" element={
						<LoggedIn secondCond={previewBlog != null}>
							<PreviewBlog />
							<Navigate to="/blogs" replace />
						</LoggedIn>
					} />

					<Route path="/profile" element={
						<LoggedIn>
							<Profile />
							<Navigate to="/login" replace />
						</LoggedIn>
					} />
					<Route path="/users" element={
						<LoggedIn secondCond={isAdmin()}>
							<Users />
							<Navigate to="/blogs" replace />
						</LoggedIn>
					} />
					<Route path="/create-new-user" element={
						<LoggedIn secondCond={isAdmin()}>
							<CreateUser />
							<Navigate to="/blogs" replace />
						</LoggedIn>
					} />
					<Route path="/profile/edit" element={
						<LoggedIn>
							<EditProfile />
							<Navigate to="/blogs" replace />
						</LoggedIn>
					} />
					<Route path="/profile/password" element={
						<LoggedIn>
							<EditPassword />
							<Navigate to="/blogs" replace />
						</LoggedIn>
					} />

					<Route path="/test" element={<Test />} />
					<Route path="*" element={<NotFound></NotFound>}></Route>

				</Routes>
			</div>
		</globalContext.Provider>
	);
}

export default App;
